export default __webpack_public_path__ + "static/media/facebook.7776b7ef.svg";